var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.278,
    height: 22.975,
    viewBox: "0 0 30.278 22.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5784",
    "data-name": "Group 5784",
    transform: "translate(-4.8 -968.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9456",
    "data-name": "Path 9456",
    d: "M7.988,968.362A3,3,0,0,0,5,971.35v16.6a3,3,0,0,0,2.988,2.988h23.9a3,3,0,0,0,2.988-2.988v-16.6a3,3,0,0,0-2.988-2.988H7.988Zm0,1.992h23.9a.973.973,0,0,1,1,1v16.6a.973.973,0,0,1-1,1H7.988a.973.973,0,0,1-1-1v-16.6A.973.973,0,0,1,7.988,970.354Zm22.294,2.967a1,1,0,0,0-.633.27l-8.974,8.092a1.086,1.086,0,0,1-1.494,0l-8.953-8.092a1,1,0,1,0-1.338,1.484l5.218,4.7L8.921,984.2a1,1,0,1,0,1.286,1.515l5.395-4.6,2.251,2.033a3.108,3.108,0,0,0,4.15,0l2.262-2.044,5.405,4.606a1,1,0,1,0,1.286-1.515l-5.187-4.429,5.208-4.7a1,1,0,0,0-.7-1.753Z",
    transform: "translate(0 0)",
    fill: "#0087c3",
    stroke: "#eaf3de",
    strokeWidth: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.2949b756b845bd1610d179584bf40912.svg";
export { ForwardRef as ReactComponent };